import { createApi } from "@reduxjs/toolkit/query/react";

import { config } from "config";
import { createBaseQueryWithAuthRefresh, prepareHeaders } from "store/base-query";
import { fmsReportBaseQuery } from "store/fms-report-base-query";

export const api = createApi({
    baseQuery: createBaseQueryWithAuthRefresh({
        baseUrl: `${config.API_URL}api/`,
        prepareHeaders,
    }),
    endpoints: () => ({}),
});

export const apiJS = createApi({
    reducerPath: "apiJS",
    baseQuery: createBaseQueryWithAuthRefresh({
        baseUrl: `${config.API_JS_URL}`,
        prepareHeaders,
    }),
    endpoints: () => ({}),
});

export const fmsReportApi = createApi({
    baseQuery: fmsReportBaseQuery,
    reducerPath: "fmsReportApi",
    endpoints: () => ({}),
});
